export const CURRENCY_DECIMALS = 2;
